export default __webpack_public_path__ + "static/profile-pic-5-671b358e5a04a73597d9acc6b84a5c41.jpeg";